import React from 'react';
import { useSplitIOTreatment } from './useSplitIOTreatment';

export const SplitHOC = (splitName) => (Component) => (props) => {
  const splitObject = useSplitIOTreatment(splitName);
  return <Component splitObject={splitObject} {...props} />;
};

export default SplitHOC;
